import { event } from '../../Foundation';
import { ProductSpot } from "../product-spot";
import { createSectionTemplate } from "./template/template";

export class AccessoriesCarousel extends HTMLElement {
    // Local variables
    #refs;

    constructor() {
        super();
        this.#refs = {
            el: this,
            prm: Sys.WebForms.PageRequestManager.getInstance()
        }
    }
    /**
     * Get content within Accessories Carousel element
     * @returns String
     */
    #fetchData() {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.innerHTML;
        return tempDiv;
    }

    /**
     * Create Template
     */
    #createTemplate() {
        const data = this.#fetchData();
        const template = createSectionTemplate(data);
        this.#refs.el.innerHTML = template;
    }

    /**
     * Show component
     */
    #loadingComplete() {
        this.classList.remove('loading');
    }

    /**
     * Update all the fields in the carousel
     * @returns 
     */
    #updateItems() {
        const eventList = [];
        const getSelectField = (element) => {
            const parentElem = element.closest('.configurator__accessories-item');
            const selectElem = parentElem.querySelector('select');
            return selectElem;
        }

        const toggleDisabled = (element, isDisabled) => {
            const selectElem = getSelectField(element);
            isDisabled ? selectElem.classList.add('is-disabled') : selectElem.classList.remove('is-disabled');
            return selectElem;
        }

        const updateFields = (e) => {
            const selectElem = getSelectField(e.target);
            if (!selectElem) return;
            const disabledSelect = selectElem.classList.contains('is-disabled');
            const elements = [...this.#refs.el.querySelectorAll(`[data-id="${e.target.dataset.id}"]`)];
            for(let element of elements) {
                const select = toggleDisabled(element, disabledSelect);
                element.value = e.target.value;
                event.emit(select, 'refresh');
                event.emit(select, 'reflow');
            };
        };
        
        let fields = [...this.#refs.el.querySelectorAll('[data-id]')];
        for (let field of fields) {
            field.removeEventListener('change', updateFields);
            if(eventList.includes(field)) return;
            field.addEventListener('change', updateFields);
            eventList.push(field);
        };
    }

    /**
     * Detect new element when scroll in carousel
     */
    #watchItemChanges() {
        const config = { attributes: true, childList: true, subtree: true };
        const observer = new MutationObserver((mutationList) => {
            this.#updateItems(mutationList);
        });
        observer.observe(this.#refs.el, config);
    }

    connectedCallback() {
        // remove element if there are no Accessories
        if(this.innerHTML.trim().length === 0) {
            this.remove();
            return;
        }
        this.#createTemplate();
        this.#loadingComplete();
        this.#watchItemChanges();
    }
}